export var EditorFlavours;
(function(EditorFlavours) {
    EditorFlavours["Journal"] = 'JOURNAL';
    EditorFlavours["Literature"] = 'LITERATURE';
    EditorFlavours["Status"] = 'STATUS';
    EditorFlavours["Comment"] = 'COMMENT';
    EditorFlavours["Commission"] = 'COMMISSION';
    EditorFlavours["DeviantId"] = 'DEVIANTID';
    EditorFlavours["PollAnswer"] = 'POLL_ANSWER';
    EditorFlavours["Donation"] = 'DONATION';
    EditorFlavours["CustomBox"] = 'CUSTOM_BOX';
    EditorFlavours["Chat"] = 'CHAT';
    EditorFlavours["Deviation"] = 'DEVIATION';
    EditorFlavours["GroupAbout"] = 'GROUP_ABOUT';
})(EditorFlavours || (EditorFlavours = {}));
export var EditorToolbars;
(function(EditorToolbars) {
    EditorToolbars["Footer"] = 'footer';
    EditorToolbars["Side"] = 'side';
    EditorToolbars["Inline"] = 'textInline';
    EditorToolbars["Static"] = 'textStatic';
    EditorToolbars["Mobile"] = 'mobile';
})(EditorToolbars || (EditorToolbars = {}));
export var KeyboardSubmitStrategy;
(function(KeyboardSubmitStrategy) {
    KeyboardSubmitStrategy[// Submits with return + cmd|alt. Return without mod key just makes a new line.
    "DEFAULT"] = "DEFAULT";
    KeyboardSubmitStrategy[// Submits with return. Return + shift makes a new line.
    "CHAT"] = "CHAT";
})(KeyboardSubmitStrategy || (KeyboardSubmitStrategy = {}));
